import { useEffect, useState } from 'react'
import { Controller } from 'react-hook-form'

import { Checkbox } from '@/components/ui/checkbox'

import { FormFieldProps } from './dynamic-input'

export const InputCheckbox = ({ field, form }: FormFieldProps) => {
  const content = field?.content
  const fieldName = `${field.id!}`
  const [selectedValues, setSelectedValues] = useState<string[]>([])

  // Initialize selected values from form when component mounts
  useEffect(() => {
    const currentValue = form.getValues(fieldName) || []
    if (Array.isArray(currentValue)) {
      setSelectedValues(currentValue)
    }
  }, [fieldName, form])

  // Helper function to update the selected values
  const updateSelectedValues = (
    label: string,
    checked: boolean | 'indeterminate',
  ) => {
    let newValues = [...selectedValues]

    if (checked === true && !newValues.includes(label)) {
      newValues.push(label)
    } else if (checked === false) {
      newValues = newValues.filter((value) => value !== label)
    }

    // Update the form
    form.setValue(fieldName, newValues, { shouldValidate: true })
    setSelectedValues(newValues)
  }

  return (
    <>
      {(content?.options || []).map((row) => (
        <div key={row.id} className="flex items-center space-x-2 mb-2">
          <Controller
            control={form.control}
            name={fieldName}
            rules={{
              validate: (value) => {
                if (content?.required) {
                  return (
                    (Array.isArray(value) && value.length > 0) ||
                    'At least one option must be selected'
                  )
                }
                return true
              },
            }}
            defaultValue={[]}
            render={() => (
              <Checkbox
                checked={selectedValues.includes(String(row.label))}
                onCheckedChange={(checked) => {
                  updateSelectedValues(String(row.label), checked)
                }}
                value={row.label}
                id={`${fieldName}-${row.id!}`}
              />
            )}
          />
          <label
            htmlFor={`${fieldName}-${row.id!}`}
            className="text-sm font-medium cursor-pointer"
          >
            {row.label}
          </label>
        </div>
      ))}
    </>
  )
}
